import { Notifier } from '@airbrake/browser'
import { app } from './main'
import { useUserStore } from './authentication/user.store'
const notAuthenticated = 'NOT_AUTHENTICATED'
const isStaging = window.location.host === 'stagingvpc.goalbookapp.com' || window.location.host === 'stagingvpc.goalbook.com'
const environment = isStaging ? 'staging' : process.env.NODE_ENV || 'development'
const projectId = import.meta.env.VITE_AIRBRAKE_PROJECT_ID
const projectKey = import.meta.env.VITE_AIRBRAKE_API_KEY
// Airbrake should not run if env variables are not present, or if Cypress is running
const allowAirbrake = projectId && projectKey && !window.Cypress

export const useAirbrake = router => {
    if (!allowAirbrake) {
        return router
    }

    const airbrake = new Notifier({
        environment,
        projectId,
        projectKey,
        keysBlocklist: ['password', 'password_confirmation']
    })

    airbrake.addFilter(notice => {
        if (notice.errors.some(error => error.message === 'Extension context invalidated.')) {
            return null
        }
        return notice
    })

    app.config.errorHandler = function (err, _vm, info) {
        console.error(err)
        const userStore = useUserStore()
        const isAuthenticated = userStore.isAuthenticated
        const userId = isAuthenticated ? userStore.userId : notAuthenticated
        airbrake.notify({
            error: err,
            params: {info: info},
            context: {
                user: {
                    id: userId
                }
            }
      });
    }

    router.onError(err => {
        console.error(err)
        const userStore = useUserStore()
        const isAuthenticated = userStore.isAuthenticated
        const userId = isAuthenticated ? userStore.userId : notAuthenticated
        airbrake.notify({
            error: err,
            context: {
                user: {
                    id: userId
                }
            }
        });
    })

    return router
}
